export default {
  zh_CN: {
    rebateTitle: '双重返佣',
    rebateDesc: '个人与好友交易手续费双重返佣',
    defaultReferral: '默认返佣',
    personRebateRate: '个人手续费返现比例',
    inviteRebateRate: '好友邀请返佣比例',
    myLink: '我的链接',
    receiveDesc: '当前待领取奖励价值 $**',
    receiveBtn: '立即领取',
    totalReward: '总返佣收入（$）',
    totalInviteCount: '累计邀请人数',
    rewardTips: '返佣收益在用户点击领取后24小时内到账',
    myInvite: '我的邀请',
    myRebate: '我的返佣',
    inviterId: '邀请人ID',
    userId: '用户ID',
    rebateRate: '关系/佣金比例',
    registerTime: '注册时间',
    sendTime: '发放时间',
    type: '类型',
    rebateContent: '返佣',
    currStatus: '状态',
    receiveReward: '领取奖励',
    rewardModalTitle: '价值 $** 奖励已领取成功',
    rewardModalDesc1: '奖励会在24小时内发放至账户',
    rewardModalDesc2: '可以在本页点击 “详情” 查看发放明细',
    PENDING: "待发放",
    CLAIMED: '已发放',
    ACCUMULATED: '已结转至下周',
    startTime: '开始时间',
    endTime: '结束时间',
    inviteReward: '邀请返佣',
    tradeReward: '交易返佣',
    chain: '链',
    totalRebate: '总返佣',
    time: '时间',
    zhi: '至',
    commissionRate: '佣金比例',
    rebateAmount: '返佣价值',
    receivedAmount: '已领价值',
    rule1Title: '交易返现',
    rule1Desc1: '在 Memeshot，每笔交易都能赚返现！',
    rule1Desc2: '返现直接来自交易手续费，并以相同链返还至你的钱包（Solana、Ethereum、BSC 或 Base）。返现等级越高，返现佣金越多 —— 最高可返还 30% 的手续费。',
    rule2Title: '返现等级',
    rule2Desc1: '- 默认等级：Lv. 1 — 5% 返现',
    rule2Desc2: '* 当你的周交易量达到更高等级要求时，等级会即时自动提升。',
    rule3Title: '邀请返佣',
    rule3Desc1: '通过邀请好友交易，笔笔赚取返佣！',
    rule3Desc2: '返佣直接来自好友的交易手续费，并以相同链资产返还至你的钱包（Solana、Ethereum、BSC 或 Base）。返佣等级越高，返佣比例越高 —— 最高可获得 50% 返佣！',
    rule4Title: '返佣等级',
    rule4Desc1: '- 默认等级：Lv.1 — 30% 返佣',
    rule4Desc2: ' 当你的周好友交易量达到更高等级要求时，等级将即时自动提升。',
    ruleLevel: '等级',
    ruleWeeklyTrading: '周交易量 (USD)',
    ruleCashback: '返现比例',
    ruleWeeklyReferral: '周好友交易量 (USD) ',
    ruleCommission: '返佣比例',
    ruleLevel1: 'Lv.1',
    ruleLevel2: 'Lv.2',
    ruleLevel3: 'Lv.3',
    ruleLevel4: 'Lv.4',
    ruleLevel5: 'Lv.5',
    ruleWeeklyVal1: '< $5000',
    ruleWeeklyVal2: '$5000 - $10000',
    ruleWeeklyVal3: '$10,000 - $50,000',
    ruleWeeklyVal4: '$50,000 - $100,000',
    ruleWeeklyVal5: '> $100,000',
  },
  en_US: {
    rebateTitle: 'Double Rewards Program',
    rebateDesc: 'Personal & referral trading fee rewards',
    defaultReferral: 'Default Rewards',
    personRebateRate: 'Cashback',
    inviteRebateRate: 'Referral Rebate',
    myLink: 'My Link',
    receiveDesc: 'Unclaimed $**',
    receiveBtn: 'Claim Now',
    totalReward: 'Total Income ($)',
    totalInviteCount: 'Invited Friends',
    rewardTips: 'Credited within 24 hours after claiming',
    myInvite: 'My Invitations',
    myRebate: 'My Rewards',
    inviterId: 'Inviter ID',
    userId: 'User ID',
    rebateRate: 'Relationship / Commission Ratio',
    registerTime: 'Registration Time',
    sendTime: 'Distribution Time',
    type: 'Type',
    rebateContent: 'Rebate',
    currStatus: 'Status',
    receiveReward: 'Claimed',
    rewardModalTitle: 'Successfully claimed $**',
    rewardModalDesc1: 'Distribution within 24 hours',
    rewardModalDesc2: 'Click "Details" for more',
    PENDING: "Pending",
    CLAIMED: 'Distributed',
    ACCUMULATED: 'Rolled to next week',
    startTime: 'Start Time',
    endTime: 'End Time',
    inviteReward: 'Referral Rewards',
    tradeReward: 'Trading Rewards',
    chain: 'Chain',
    totalRebate: 'Total Rewards',
    time: 'Time',
    zhi: 'To',
    commissionRate: 'Commission Ratio',
    rebateAmount: 'Rebate Value',
    receivedAmount: 'Claimed',
    rule1Title: 'Trade & Earn',
    rule1Desc1: 'Every trade on Memeshot earns you cashback!',
    rule1Desc2: 'Cashback comes straight from trading fees and is returned in the same chain you traded (Solana, Ethereum, BSC, or Base). The higher your cashback level, the more you earn—up to 30% of fees back at the top tier.',
    rule2Title: 'Cashback Levels',
    rule2Desc1: '- Default: Lv.1 — 5% cashback',
    rule2Desc2: '* Levels upgrade automatically when you reach the next volume tier.',
    rule3Title: 'Invite & Earn',
    rule3Desc1: 'Earn commission every time someone you referred makes a trade.',
    rule3Desc2: 'Commission is taken directly from their trading fees and paid to your wallet on the same chain (Solana, Ethereum, BSC, or Base). The higher your commission level, the more you earn—up to 50% of fees at the top tier.',
    rule4Title: 'Commission Levels',
    rule4Desc1: '- Default: Lv.1 — 30% commission.',
    rule4Desc2: ' * Levels upgrade automatically when you reach the next volume tier. ',
    ruleLevel: 'Level',
    ruleWeeklyTrading: 'Weekly Trading Volume (USD)',
    ruleCashback: 'Cashback',
    ruleWeeklyReferral: 'Weekly Referral Volume (USD)',
    ruleCommission: 'Your Commission',
    ruleLevel1: 'Lv.1',
    ruleLevel2: 'Lv.2',
    ruleLevel3: 'Lv.3',
    ruleLevel4: 'Lv.4',
    ruleLevel5: 'Lv.5',
    ruleWeeklyVal1: '< $5000',
    ruleWeeklyVal2: '$5000 - $10000',
    ruleWeeklyVal3: '$10,000 - $50,000',
    ruleWeeklyVal4: '$50,000 - $100,000',
    ruleWeeklyVal5: '> $100,000',
  },
  ar_SA: {
    rebateTitle: 'مكافآت مزدوجة',
    rebateDesc: 'كاش باك لرسوم التداول والإحالات',
    defaultReferral: 'المكافآة الافتراضية',
    personRebateRate: 'كاش باك',
    inviteRebateRate: 'نسبة إحالتي',
    myLink: 'رابط الدعوة',
    receiveDesc: 'قابل للأستلام $**',
    receiveBtn: 'أستلام الان',
    totalReward: 'إجمالي العوائد ($)',
    totalInviteCount: 'الأصدقاء المدعوون',
    rewardTips: 'يتم إضافتها إلى الرصيد خلال 24 ساعة بعد الاستلام',
    myInvite: 'دعواتي',
    myRebate: 'عوائدي',
    inviterId: 'معرف الداعي',
    userId: 'معرف المستخدم',
    rebateRate: 'العلاقة / نسبة العمولة',
    registerTime: 'وقت التسجيل',
    sendTime: 'وقت التوزيع',
    type: 'النوع',
    rebateContent: 'العائد',
    currStatus: 'الحالة',
    receiveReward: 'تم الاستلام',
    rewardModalTitle: 'تم استلام $** بنجاح',
    rewardModalDesc1: 'التوزيع يتم خلال 24 ساعة',
    rewardModalDesc2: 'انقر على "التفاصيل" للمزيد',
    PENDING: "قيد الانتظار",
    CLAIMED: 'تم الاستلام',
    ACCUMULATED: 'مُرحّل إلى الأسبوع التالي',
    startTime: 'وقت البداية',
    endTime: 'وقت النهاية',
    inviteReward: 'عوائد الإحالات',
    tradeReward: 'عوائد التداول',
    chain: 'الشبكة',
    totalRebate: 'إجمالي العوائد',
    time: 'الوقت',
    zhi: 'إلى',
    commissionRate: 'نسبة العمولة',
    rebateAmount: 'العوائد',
    receivedAmount: 'مستلم',
    rule1Title: 'تداول واربح',
    rule1Desc1: 'كل عملية تداول على ميم شوت تمنحك كاش باك!',
    rule1Desc2: 'يُستقطع الكاش باك مباشرة من رسوم التداول ويُعاد إلى محفظتك على نفس الشبكة التي تمت فيها الصفقة (Solana أو Ethereum أو BSC أو Base). كلما حجم التداول، زادت نسبة الكاش باك — حتى 30% كحد أقصى.',
    rule2Title: 'مستويات الكاش باك',
    rule2Desc1: 'المستوى الافتراضي: م.الاول — 5% كاش باك',
    rule2Desc2: '* يتم ترقية المستوى تلقائيًا فور تجاوز حد حجم التداول المطلوب للمستوى التالي.',
    rule3Title: 'ادعُ واربح',
    rule3Desc1: 'اكسب عمولة كلما أجرى أحد المدعوين عملية تداول.',
    rule3Desc2: '❖ تُستقطع العمولة مباشرة من رسوم تداولات المدعويين، وتحول إلى محفظتك على نفس الشبكة التي تم فيها التداول (Solana أو Ethereum أو BSC أو Base). كلما ارتفع حجم تداول الإحالات، زادت نسبة العمولة — حتى 50% من الرسوم في أعلى مستوى.',
    rule4Title: 'مستويات العمولة',
    rule4Desc1: 'المستوى الافتراضي: م.الاول — العمولة 30%',
    rule4Desc2: ' * يتم ترقية المستوى تلقائيًا فور تجاوز حد حجم التداول المطلوب للمستوى التالي.',
    ruleLevel: 'المستوى',
    ruleWeeklyTrading: 'حجم التداول الأسبوعي ($)',
    ruleCashback: 'كاش باك',
    ruleWeeklyReferral: 'حجم تداول الإحالات الأسبوعي ($)',
    ruleCommission: 'عمولتك',
    ruleLevel1: 'الاول',
    ruleLevel2: 'الثاني',
    ruleLevel3: 'الثالث',
    ruleLevel4: 'الرابعة',
    ruleLevel5: 'الخامسة',
    ruleWeeklyVal1: ' أصغر من 5000$',
    ruleWeeklyVal2: '$5000 - $10000',
    ruleWeeklyVal3: '$10,000 - $50,000',
    ruleWeeklyVal4: '$50,000 - $100,000',
    ruleWeeklyVal5: 'أكبر من 100,000$',
  },
  tr_TR: {
    rebateTitle: 'Çift İndirim',
    rebateDesc: 'Kişisel ve yönlendirme işlem indirimleri',
    defaultReferral: 'Varsayılan İndirim',
    personRebateRate: 'Komisyon İadem',
    inviteRebateRate: 'Yönlendirme İndirimim',
    myLink: 'Bağlantım',
    receiveDesc: 'Talep Edilmemiş $**',
    receiveBtn: 'Şimdi Talep Et',
    totalReward: 'Toplam Gelir ($)',
    totalInviteCount: 'Davet Edilen Arkadaşlar',
    rewardTips: 'Talep ettikten sonra 24 saat içinde hesabınıza geçer',
    myInvite: 'Davetlerim',
    myRebate: 'İndirimlerim',
    inviterId: 'Davet Eden ID',
    userId: 'Kullanıcı ID',
    rebateRate: 'İlişki / Komisyon Oranı',
    registerTime: 'Kayıt Zamanı',
    sendTime: 'Dağıtım Zamanı',
    type: 'Tür',
    rebateContent: 'İndirim',
    currStatus: 'Durum',
    receiveReward: 'Talep Edildi',
    rewardModalTitle: '$** başarıyla talep edildi',
    rewardModalDesc1: '24 saat içinde dağıtım',
    rewardModalDesc2: 'Daha fazlası için "Detaylar"a tıklayın',
    PENDING: "Beklemede",
    CLAIMED: 'Dağıtıldı',
    ACCUMULATED: 'Gelecek haftaya devredildi',
    startTime: 'Başlangıç Zamanı',
    endTime: 'Bitiş Zamanı',
    inviteReward: 'Yönlendirme İndirimi',
    tradeReward: 'İşlem İndirimi',
    chain: 'Zincir',
    totalRebate: 'Toplam İndirim',
    time: 'Zaman',
    zhi: 'Kime',
    commissionRate: 'Komisyon Oranı',
    rebateAmount: 'İndirim Değeri',
    receivedAmount: 'Talep Edildi',
    rule1Title: 'Al-Sat ve Kazan',
    rule1Desc1: 'Memeshot’ta yaptığın her işlem sana geri ödeme kazandırır!',
    rule1Desc2: 'Geri ödeme, işlem ücretlerinden karşılanır ve işlemi gerçekleştirdiğin aynı ağdaki cüzdanına aktarılır (Solana, Ethereum, BSC veya Base). Geri ödeme seviyen ne kadar yüksekse, kazancın da o kadar artar — en üst seviyede ücretlerin %30’una kadar geri alabilirsin.',
    rule2Title: 'Geri Ödeme Seviyeleri',
    rule2Desc1: 'Varsayılan: Lv.1 — %5 geri ödeme',
    rule2Desc2: '* Hedef işlem hacmine ulaştığında seviye otomatik olarak yükselir.',
    rule3Title: 'Davet Et ve Kazan',
    rule3Desc1: 'Davet ettiğin her kullanıcı işlem yaptığında komisyon kazanırsın!',
    rule3Desc2: 'Komisyon, davetlinin ödediği işlem ücretlerinden tahsil edilir ve işlemin gerçekleştiği aynı ağdaki cüzdanına (Solana, Ethereum, BSC veya Base) yatırılır. Komisyon seviyen ne kadar yüksekse kazancın da o kadar artar — en üst seviyede ücretlerin %50’sine kadar kazanabilirsin.',
    rule4Title: 'Komisyon Seviyeleri',
    rule4Desc1: 'Varsayılan: Lv.1 — %30 komisyon',
    rule4Desc2: '* Hedef işlem hacmine ulaştığında seviye otomatik olarak yükselir.',
    ruleLevel: 'Seviye',
    ruleWeeklyTrading: 'Haftalık İşlem Hacmi (USD)',
    ruleCashback: 'Geri Ödeme',
    ruleWeeklyReferral: 'Haftalık Davetli Hacmi (USD) ',
    ruleCommission: 'Komisyon Oranın',
    ruleLevel1: 'Lv.1',
    ruleLevel2: 'Lv.2',
    ruleLevel3: 'Lv.3',
    ruleLevel4: 'Lv.4',
    ruleLevel5: 'Lv.5',
    ruleWeeklyVal1: '< $5000',
    ruleWeeklyVal2: '$5000 - $10000',
    ruleWeeklyVal3: '$10,000 - $50,000',
    ruleWeeklyVal4: '$50,000 - $100,000',
    ruleWeeklyVal5: '> $100,000',
  },
  ko_KR: {
    rebateTitle: '더블 리베이트',
    rebateDesc: '개인 및 추천 거래 리베이트',
    defaultReferral: '기본 리베이트',
    personRebateRate: '내 수수료 캐시백',
    inviteRebateRate: '내 추천 리베이트',
    myLink: '내 링크',
    receiveDesc: '미청구 $**',
    receiveBtn: '지금 청구하기',
    totalReward: '총 수입 ($)',
    totalInviteCount: '초대한 친구',
    rewardTips: '청구 후 24시간 이내 입금',
    myInvite: '내 초대',
    myRebate: '내 리베이트',
    inviterId: '초대자 ID',
    userId: '사용자 ID',
    rebateRate: '관계 / 수수료 비율',
    registerTime: '등록 시간',
    sendTime: '배분 시간',
    type: '유형',
    rebateContent: '리베이트',
    currStatus: '상태',
    receiveReward: '청구됨',
    rewardModalTitle: '$** 성공적으로 청구됨',
    rewardModalDesc1: '24시간 이내 배분',
    rewardModalDesc2: '자세히 보려면 "상세" 클릭',
    PENDING: "대기 중",
    CLAIMED: '배분됨',
    ACCUMULATED: '다음 주로 이월',
    startTime: '시작 시간',
    endTime: '종료 시간',
    inviteReward: '추천 리베이트',
    tradeReward: '거래 리베이트',
    chain: '체인',
    totalRebate: '총 리베이트',
    time: '시간',
    zhi: '수신',
    commissionRate: '수수료 비율',
    rebateAmount: '리베이트 금액',
    receivedAmount: '청구됨',
    rule1Title: '거래 & 리워드',
    rule1Desc1: 'Memeshot에서 거래할 때마다 캐시백을 받아보세요!',
    rule1Desc2: '캐시백은 거래 수수료에서 즉시 차감되어, 거래한 동일 체인(Solana, Ethereum, BSC, Base)의 지갑으로 돌려드립니다. 캐시백 레벨이 높을수록 환급률이 커지며, 최고 등급에서는 수수료의 최대 30%까지 돌려받을 수 있습니다.',
    rule2Title: '캐시백 레벨',
    rule2Desc1: '기본 등급: Lv.1 — 5% 캐시백',
    rule2Desc2: '* 목표 거래량을 달성하면 레벨이 즉시 자동 승급됩니다.',
    rule3Title: '초대 & 수익',
    rule3Desc1: '내가 초대한 친구가 거래할 때마다 커미션을 받아보세요!',
    rule3Desc2: '커미션은 친구가 낸 거래 수수료에서 직접 공제되어, 거래가 발생한 동일 체인(Solana, Ethereum, BSC, Base) 지갑으로 즉시 지급됩니다. 커미션 레벨이 높을수록 수익도 커지며, 최고 등급에서는 수수료의 최대 50% 까지 받아볼 수 있습니다.',
    rule4Title: '커미션 레벨',
    rule4Desc1: '기본 등급: Lv.1 — 30% 커미션',
    rule4Desc2: '* 목표 거래량을 달성하면 레벨이 즉시 자동 승급됩니다.',
    ruleLevel: '레벨',
    ruleWeeklyTrading: '주간 거래량 (USD)',
    ruleCashback: '캐시백',
    ruleWeeklyReferral: '주간 초대 거래량 (USD) ',
    ruleCommission: '내 커미션',
    ruleLevel1: 'Lv.1',
    ruleLevel2: 'Lv.2',
    ruleLevel3: 'Lv.3',
    ruleLevel4: 'Lv.4',
    ruleLevel5: 'Lv.5',
    ruleWeeklyVal1: '< $5000',
    ruleWeeklyVal2: '$5000 - $10000',
    ruleWeeklyVal3: '$10,000 - $50,000',
    ruleWeeklyVal4: '$50,000 - $100,000',
    ruleWeeklyVal5: '> $100,000',
  }
}